<template>
  <footer>
    <div class="footer-inner">
      <div class="menu-list">
        <div class="menu-title">Product</div>
        <ul>
          <li class="bold">Trading Platforms</li>
          <li><router-link to="tap"> TAP Trader</router-link></li>
          <li><router-link to="delkoithts">DELKOIT HTS</router-link></li>
        </ul>
      </div>
      <div class="menu-list">
        <div class="menu-title">Solutions</div>
        <ul>
          <li class="bold">Trading Platforms Components</li>
          <li><router-link to="webtradingterminal">Web Trader</router-link></li>
          <li><router-link to="mobiletradingterminal">Mobile App</router-link></li>
          <li><router-link to="ordermanagementsystem">Order Management System</router-link></li>
          <li><router-link to="riskmanagementsystem">Risk Management System</router-link></li>
          <li class="bold"><router-link to="shortselling">Short Selling Simulator</router-link></li>
          <li class="bold"><router-link to="derivativessimulator">Derivatives Simulator</router-link></li>
          <li class="bold"><router-link to="autotrading">Auto Trading System</router-link></li>
          <li class="bold"><router-link to="sto">STO Issuance System</router-link></li>
        </ul>
      </div>
      <div class="menu-list">
        <div class="menu-title">Services</div>
        <ul>
          <li class="bold"><router-link to="tradingsoftwaredev">Financial Software Development</router-link></li>
          <li class="bold"><router-link to="autotradingsignal">Auto Trading Signal Data</router-link></li>
        </ul>
      </div>
      <div class="menu-list">
        <div class="menu-title">Company</div>
        <ul>
          <li class="bold"><router-link to="about">About</router-link></li>
          <li class="bold"><router-link to="contact">Contact</router-link></li>
        </ul>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="bottom-inner">
        <img class="logo" src="@/assets/images/logo-white.png" alt="" />
        <p>
          Copyright © 2021-2024 Delkoit Limited. All Rights Reserved. Delkoit is a software business that provides software products and services.
          <br />
          Delkoit does not provide any investment advice or brokerage services
          <br />
          <span style="font-size: 12px;">{{$t('miniFooter.text1')}}</span>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped></style>
